import { useMemo, useState } from 'react';
import MasterAdminScreenMount, { MASTER_ADMIN_PREVIEW_SCREENS } from './MasterAdminScreenMount';
import { formatScreenCode } from '../lib/screenRegistry';
import './MasterAdminMaintenancePreview.css';

/** Tab 7 — Maintenance Preview: review MPL-01..MPL-10 in the master admin console. */
export default function MasterAdminMaintenancePreview() {
  const [activeScreenId, setActiveScreenId] = useState(
    MASTER_ADMIN_PREVIEW_SCREENS[0]?.screenId ?? 'Screen-MPL-01',
  );

  const activeScreen = useMemo(
    () => MASTER_ADMIN_PREVIEW_SCREENS.find((item) => item.screenId === activeScreenId)
      ?? MASTER_ADMIN_PREVIEW_SCREENS[0],
    [activeScreenId],
  );

  return (
    <div className="maintenance-preview-workspace">
      <aside className="maintenance-preview-tree" aria-label="Mentology Classroom screens">
        <div className="maintenance-preview-tree-scroll">
          {MASTER_ADMIN_PREVIEW_SCREENS.map((item) => (
            <button
              key={item.screenId}
              type="button"
              className={`maintenance-preview-tree-item ${activeScreenId === item.screenId ? 'active' : ''}`}
              onClick={() => setActiveScreenId(item.screenId)}
            >
              <span className="maintenance-preview-tree-id">{formatScreenCode(item.screenId)}</span>
              <span className="maintenance-preview-tree-label">{item.label}</span>
              <span className="maintenance-preview-tree-route">{item.route}</span>
            </button>
          ))}
        </div>
      </aside>
      <main className="maintenance-preview-canvas" aria-label="Live screen preview canvas">
        <div className="maintenance-preview-canvas-header">
          <p className="maintenance-preview-canvas-label">{activeScreen.label}</p>
          <p className="maintenance-preview-canvas-route">Route: {activeScreen.route}</p>
        </div>
        <div className="maintenance-preview-canvas-body">
          <MasterAdminScreenMount key={activeScreenId} screenId={activeScreenId} />
        </div>
      </main>
    </div>
  );
}

export { MASTER_ADMIN_PREVIEW_SCREENS };
